import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ReactComponent as OutlineNewscreen } from "assets/svg/outline-newscreen.svg";

import messages from "messages";
import StripeSetupButton from "../stripe-setup-button";
import Checkbox from "components/checkbox/Checkbox";
import { track } from "utils/amplitude";

const ConnectWithStripe = ({
  title,
  amplitudePageName,
  amplitudeComponentName,
  ...props
}) => {
  const [checked, setChecked] = useState(false);
  const [show, setShow] = useState(false);

  return (
    <>
      <Button
        onClick={() => {
          track(
            amplitudePageName,
            amplitudeComponentName
              ? [amplitudeComponentName, "setup-payment-method-buton"]
              : "setup-payment-method-buton",

            "click",
          );
          setShow(true);
        }}
        {...props}
      >
        {title || messages.setupPaymentMethod}
      </Button>
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={() => setShow(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Setup payment method</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "50vh" }}>
          <p className="mb-0 fs-14 fw-500">Setup payment method</p>
          <p className="fs-12 gray01">
            In order to activate your sessions and see them live on the
            platform, setup your preferred payment menthod. You can always skip
            this step now and setup at a later time.
          </p>
          <StripeSetupButton
            disabled={!checked}
            variant="outline-primary"
            className="p-btn"
            amplitudePageName={amplitudePageName}
            amplitudeComponentName={amplitudeComponentName}
            children={
              <>
                <OutlineNewscreen className={"mr-1"} />
                Setup
              </>
            }
          />
          <div
            className="d-flex align-items-center position-absolute"
            style={{ bottom: "0" }}
          >
            <Checkbox
              checked={checked}
              onChange={(e) => {
                track(
                  amplitudePageName,
                  amplitudeComponentName
                    ? [
                        amplitudeComponentName,
                        "independent-contractor-agreement-checkbox",
                      ]
                    : "independent-contractor-agreement-checkbox",
                  "click",
                );
                setChecked(e.target.checked);
              }}
              id="independent-contractor-agreement"
              label={
                <label>
                  I have read and agree to the{" "}
                  <Link
                    to="/independent-contractor-agreement"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      track(
                        amplitudePageName,
                        amplitudeComponentName
                          ? [
                              amplitudeComponentName,
                              "independent-contractor-agreement-link",
                            ]
                          : "independent-contractor-agreement-link",
                        "click",
                      );
                    }}
                  >
                    Independent Contractor Agreement{" "}
                  </Link>
                  <span className="required">{"*"}</span>
                </label>
              }
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-primary"
            size="sm"
            className="p-btn"
            onClick={() => {
              track(
                amplitudePageName,
                amplitudeComponentName
                  ? [amplitudeComponentName, "skip-and-do-later-button"]
                  : "skip-and-do-later-button",
                "click",
              );
              setShow(false);
            }}
          >
            Skip and do later
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConnectWithStripe;
